import React from "react";
import AnimatedNumber from "../animations/AnimatedNumber";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { NOC_PRIMARY } from "../../utilities/constants/colors";

const DashboardCardWithAnimatedValue = ({
  setFilterText,
  title,
  value,
  filterKey,
  showRupeeSymbol,
  isLoading,
  filterText,
}) => {
  return (
    <>
      <div
        className={`${filterText != filterKey ? "cursor-pointer" : ""} w-full`}
      >
        <div
          onClick={() => {
            setFilterText(filterKey);
          }}
          key={filterKey}
          //   ${filterKey != null && filterKey != "" && value == 0 ? "border-slate-200 bg-white" : ""} // style
          className={`rounded-lg border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900`}
        >
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400">
            {title}
          </p>
          <p
            style={{ color: NOC_PRIMARY }}
            className={`mt-1 text-lg font-semibold dark:text-white`}
          >
            {isLoading ? (
              <span>
                {" "}
                <AiOutlineLoading3Quarters className="animate-spin" size={25} />
              </span>
            ) : (
              <AnimatedNumber
                value={value}
                prefix={showRupeeSymbol ? "₹ " : ""}
                duration={1500}
              />
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export default DashboardCardWithAnimatedValue;
